// next/image quality for property-uploaded imagery (hero, sliders, section
// images). Kept high enough that thumbnails do not look degraded next to the
// original upload; see BOOK-8165.
export const GUEST_PORTAL_IMAGE_QUALITY = 85;
